import React from "react";
import altare from '../assets/Group.png';

const Status = ({ image, title, data, status }) => {

    const widthStyle = status === "reject" ? "380px" : "430px";
    const widthStyle1 = status === "reject" ? "330px" : "400px";
    return (
        <div className="container-success">
            <div className="container-logo">
                <div className="logo" style={{ height: '200px' }}>
                    {image && <img src={image} alt="ping" style={{ width: "140px", height: '140px', borderRadius: '10px' }}></img>}
                </div>
                <div className="success-text" style={{width : widthStyle}}>{title}</div>
                <div className="redirect-text" style={{width :widthStyle1}}>{data}</div>
            </div>
            <div className="footer-text">Powered by
                <img src={altare} alt="powered-logo" style={{ width: "50px", height: '20px' }} />
            </div>
        </div>
    )
}

export default Status;